module.exports = __webpack_public_path__ + "static/media/5.d2f66987.JPG";